import type { ResourceKind } from '../../lib/data-model';

export type KindBadge = { glyph: string; bg: string; fg: string };

/** Kind glyph + tint, per design.html resource rows. */
export function kindBadge(kind: ResourceKind): KindBadge {
  switch (kind) {
    case 'video':
      return { glyph: '\u25B6', bg: 'var(--t-green)', fg: 'var(--c-green)' };
    case 'pdf':
      return { glyph: '\u25A4', bg: 'var(--t-amber)', fg: 'var(--c-amber)' };
    case 'link':
      return { glyph: '\u2197', bg: 'var(--t-blue)', fg: 'var(--c-blue)' };
    default:
      return { glyph: '?', bg: 'var(--t-plum)', fg: 'var(--c-plum)' };
  }
}

export const KIND_LABEL: Record<ResourceKind, string> = { video: 'VIDEO', pdf: 'PDF', file: 'FILE', link: 'LINK' };
export const KIND_ACTION: Record<ResourceKind, string> = { video: 'Watch', pdf: 'Read', file: 'Open', link: 'Open' };

/** Chapter card palette, cycled by position (mirrors design.html PALETTES). */
export function paletteFor(i: number): { tint: string; accent: string; deep: string; glyph: string } {
  const palettes = [
    { tint: 'var(--t-green)', accent: 'var(--brand)', deep: 'var(--c-green)', glyph: '\u222B' },
    { tint: 'var(--t-plum)', accent: 'var(--plum)', deep: 'var(--c-plum)', glyph: '\u2202' },
    { tint: 'var(--t-amber)', accent: 'var(--amber)', deep: 'var(--c-amber)', glyph: '\u03A3' },
    { tint: 'var(--t-blue)', accent: '#3B82C4', deep: 'var(--c-blue)', glyph: '\u03C0' },
    { tint: 'var(--t-indigo)', accent: '#6B6FD1', deep: 'var(--c-indigo)', glyph: '\u03B8' },
    { tint: 'var(--t-terra)', accent: '#D2703F', deep: 'var(--c-terra)', glyph: '\u0394' }
  ];
  return palettes[i % palettes.length];
}

/** Bar fill: full green, partial amber, empty hairline (per design barColor). */
export function barColor(pct: number): string {
  return pct === 100 ? 'var(--brand)' : pct > 0 ? '#FFC53D' : 'var(--line)';
}

export function pctOf(ids: string[], done: Set<string>): { pct: number; d: number; n: number } {
  let d = 0;
  for (const id of ids) if (done.has(id)) d++;
  return { pct: ids.length ? Math.round((d / ids.length) * 100) : 0, d, n: ids.length };
}

/** Meta line for a resource row (falls back to kind). */
export function resMeta(meta: string | undefined, kind: ResourceKind): string {
  return meta && meta.trim() ? meta : kind.toUpperCase();
}
